import React, { useEffect, useState, useContext } from 'react';
import { ordersPathTo } from '../utils/Api';
import OrderCard from './OrderCard';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SnackbarContext from '../contexts/SnackbarContext';

const DeliveryDashboard = () => {
  const [ordersList, setOrdersList] = useState([]);
  const takenOrders = ordersList.filter((o) => o.status === "courier");
  const toBeTakenOrders = ordersList.filter((o) => o.status === "paid");
  const { openConfirmDialog, openSnackbar } = useContext(SnackbarContext);
  const navigate = useNavigate();

  useEffect(() => {
    ordersPathTo.delivery_list().then(result => {
      setOrdersList(result.data)
    })
  }, [])

  const handleAcceptOrder = (order) => {
    openConfirmDialog(
      "Aceitar entregar este pedido?",
      async () => {
        try {
          const result = await ordersPathTo.add_courier(order.id);
          setOrdersList(ordersList.map((order) => (order.id === result.data.id ? result.data : order)));
          openSnackbar("Pedido aceito!", "success");
        } catch (error) {
          console.error("Error accepting order:", error);
          // Optionally call openSnackbar to show error
          openSnackbar("Erro ao aceitar Pedido!", "error");
        }
      }
    );
  };

  const toBeTakenOrdersList = () => {
    if (toBeTakenOrders.length === 0) return;
      
    return (
      <Box>
        <Typography color="primary" variant="h5">
          <b>Outros pedidos</b>
        </Typography>
        {toBeTakenOrders.map((order) => (
          <OrderCard key={order.id} order={order} handleCardClick={() => handleAcceptOrder(order)}/>
        ))}
      </Box>
    )
  }

  const takenOrdersList = () => {
    if (takenOrders.length === 0) return;
      
    return (
      <Box>
        <Typography color="primary" variant="h5">
          <b>Seus pedidos ativos</b>
        </Typography>
        {takenOrders.map((order) => (
          <OrderCard key={order.id} order={order} handleCardClick={() => navigate(`/orders/${order.id}/delivery`)}/>
        ))}
      </Box>
    )
  }

  if (ordersList.length === 0) {
    return (
      <Box mt={2}>
        <Typography variant="p" color="primary">
            <b>Carregando...</b>
        </Typography>
      </Box>
    )
  }

  return (
    <div>
    <Typography variant="h4" color="primary">
      Painel do entregador
    </Typography>
      <br />
      <br />
      <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
        {takenOrdersList()}
        
        {toBeTakenOrdersList()}
      </Box>
    </div>
  )
}

export default DeliveryDashboard